/*
 * Feey • MENGENRABATT collection badge
 *
 * Two jobs:
 *   1) Owns the badge styling. Same <style> block applies to Liquid- and
 *      JS-rendered badges so the look stays consistent.
 *   2) Injects the badge into product tiles that Boost USF (or similar
 *      filter/search apps) renders client-side, since those skip the theme's
 *      Liquid product card.
 *
 * Placement: the badge is an inline pill that sits ABOVE the product title in
 * the tile's text/meta area — not an overlay on the image. This avoids
 * collisions with theme/app-rendered corner badges (Bestseller, sale, etc.)
 * and scales cleanly across desktop and mobile.
 *
 * Bestseller styling: also includes a CSS override so the theme's custom-label
 * badge renders in feey Green (matches Boost + brand guide), not the default
 * black.
 */
(function () {
  // Handles of products that should carry the MENGENRABATT badge.
  var SOIL_HANDLES = [
    'zimmerpflanzenerde',
    'erde-balkonpflanzen-gartenpflanzen'
  ];

  // Selectors for the product title element inside a tile, in priority order.
  // We insert the badge immediately before whichever one is found.
  var TITLE_SELECTORS = [
    '.grid-product__title',
    '.boost-pfs-filter-product-item-title',
    '.boost-pfs-product-item-title',
    '.product-item-title',
    'h3, h4'
  ];

  var STYLE_ID = 'feey-mr-style';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      /* Note: per-product badge colors come from the "impulse-feey.product_   */
      /* badge" JSON metafield as inline styles (mirrors Boost). No CSS color  */
      /* override here — the metafield is the source of truth.                 */

      /* MENGENRABATT pill — inline element above the product title.          */
      '.feey-mengenrabatt-tag{',
      '  display:inline-block;',
      '  background-color:#FACE44;',
      '  color:#141414;',
      '  font-family:Poppins,sans-serif;',
      '  font-size:10px;',
      '  font-weight:600;',
      '  letter-spacing:0.08em;',
      '  text-transform:uppercase;',
      '  line-height:1;',
      '  padding:5px 9px;',
      '  border-radius:4px;',
      '  margin:0 0 6px;',
      '  text-decoration:none;',
      '  white-space:nowrap;',
      '  transition:background-color 0.15s ease;',
      '}',
      '.feey-mengenrabatt-tag:hover,',
      '.feey-mengenrabatt-tag:focus{',
      '  background-color:#f5c130;',
      '  color:#141414;',
      '  text-decoration:none;',
      '}',
      '@media only screen and (min-width:769px){',
      '  .feey-mengenrabatt-tag{',
      '    font-size:11px;',
      '    padding:6px 10px;',
      '  }',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }

  function buildBadge(handle) {
    var a = document.createElement('a');
    a.className = 'feey-mengenrabatt-tag';
    a.href = '/products/' + handle + '?quantity=2';
    a.textContent = 'Kaufe 2, spare 5%';
    a.setAttribute('aria-label', 'Mengenrabatt: kaufe mehr, spare mehr');
    return a;
  }

  function findTitle(tile) {
    for (var i = 0; i < TITLE_SELECTORS.length; i++) {
      try {
        var el = tile.querySelector(TITLE_SELECTORS[i]);
        if (el) return el;
      } catch (e) { /* invalid selector — skip */ }
    }
    return null;
  }

  function inject(tile) {
    if (!tile || tile.nodeType !== 1) return;
    var handle = tile.getAttribute('data-product-handle');
    if (!handle || SOIL_HANDLES.indexOf(handle) === -1) return;

    // Skip if a badge is already there (Liquid render path or earlier inject).
    if (tile.querySelector('.feey-mengenrabatt-tag')) return;

    var title = findTitle(tile);
    if (!title || !title.parentElement) return;

    title.parentElement.insertBefore(buildBadge(handle), title);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tiles = scope.querySelectorAll('[data-product-handle]');
    for (var i = 0; i < tiles.length; i++) inject(tiles[i]);
  }

  function init() {
    ensureStyle();
    scan(document);

    var debounce;
    var observer = new MutationObserver(function (mutations) {
      var needsScan = false;
      for (var i = 0; i < mutations.length && !needsScan; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute && n.hasAttribute('data-product-handle')) { needsScan = true; break; }
          if (n.querySelector && n.querySelector('[data-product-handle]')) { needsScan = true; break; }
        }
      }
      if (!needsScan) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () { scan(document); }, 60);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
